<template>
  <v-row
    align="center"
    justify="center"
    align-content="center"
    justify-content="center"
  >
    <v-col cols="12" lg="6" align="center">
      <v-card class="padding-20">
        <div class="padding-20">
          <h2>Sign In</h2>
        </div>
        <v-form ref="form">
          <v-text-field
            v-model="email"
            color="primary"
            label="email"
            required
            outlined
            prepend-inner-icon="fas fa-envelope"
          ></v-text-field>
          <v-text-field
            v-model="password"
            color="primary"
            label="password"
            :type="'password'"
            prepend-inner-icon="fa fa-lock"
            required
            outlined
          ></v-text-field>
          <v-alert :value="hasError" type="error" color="error" outlined>{{
            error.message
          }}</v-alert>
          <v-btn color="primary" large text @click="login">Sign In</v-btn>
          <div class="padding-10">
            <router-link to="/signup">Not a user? Sign Up</router-link>
          </div>
          <v-snackbar
            v-model="snackbar"
            color="info darken-1"
            :timeout="3000"
            light
            top
          >
            <v-avatar icon>
              <v-icon color="white" small>check</v-icon> </v-avatar
            >Successfully signed in, redirecting. . .
            <v-btn text @click="snackbar = false" to="/household">Close</v-btn>
          </v-snackbar>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { membersRef, adminsRef, firebaseApp } from "../firebaseApp";
export default {
  data: () => ({
    email: "",
    snackbar: false,
    response: "",
    hasError: false,
    password: "",
    user: {},
    error: {
      message: "",
    },
  }),
  methods: {
    login: function () {
      firebaseApp
        .auth()
        .signInWithEmailAndPassword(this.email.trim(), this.password)
        .then(() => {
          var firebaseUser = firebaseApp.auth().currentUser;
          var user = {};
          user.email = firebaseUser.email;
          user.verified = firebaseUser.emailVerified;
          user.creationTime = firebaseUser.metadata.creationTime;
          user.lastSignIn = firebaseUser.metadata.lastSignInTime;
          if (this.isUserVerified()) {
            this.$store.dispatch("signIn", user);
            this.$store.dispatch("loggedIn");
            this.setAdmin(user.email);
            this.setMember(user.email);
          } else {
            firebaseUser.sendEmailVerification();
            this.error.message =
              "We've sent a verification email. Please confirm your account before signing in.";
            this.hasError = true;
          }
        })
        .catch((error) => {
          this.error.message = error.message;
          this.hasError = true;
        });
    },
    setMember(userEmail) {
      let member_payload = {};
      membersRef.once("value", (snap) => {
        snap.forEach((member) => {
          if (member.val().email == userEmail) {
            member_payload = member.val();
            member_payload.id = member.key;
            this.snackbar = true;
            this.$store.dispatch("setMember", member_payload);
            setTimeout(() => this.$router.push({ path: "/household" }), 3000);
          }
        });
      });
    },
    setAdmin(userEmail) {
      let admin_payload = {};
      let isAdmin = false;
      adminsRef.once("value", (snap) => {
        snap.forEach((admin) => {
          if (
            admin.val().email == userEmail &&
            admin.val().superVerified == true
          ) {
            admin_payload = admin.val();
            admin_payload.id = admin.key;
            isAdmin = true;
            this.$store.dispatch("setAdmin", admin_payload);
            if (admin_payload.towingCompany == true) {
              setTimeout(
                () => this.$router.push({ path: "/visitorslog" }),
                3000
              );
            } else {
              setTimeout(() => this.$router.push({ path: "/household" }), 3000);
            }
          }
        });
        if (!isAdmin) {
          sessionStorage.removeItem("admin");
        }
      });
    },
    isUserVerified() {
      var user = firebaseApp.auth().currentUser;
      return user.emailVerified;
    },
  },
};
</script>
